import { DataCoreBaseProduct } from "@towersystems/roam-common/lib/generated-types";
import Location from "../../../../utilities/data/model/Location";
import {
  withObservables,
  ExtractedObservables,
} from "@nozbe/watermelondb/react";
import { Card, FlatActionList } from "@towersystems/roam-common-native";
import { moneyToFormattedString } from "@towersystems/roam-common/lib/shared-utils";
import { Text } from "@towersystems/roam-common-native/lib/components";
import StockCount from "../../../../utilities/data/model/StockCount";

const getObservables = ({ stockCount }: { stockCount: StockCount }) => ({
  location: stockCount.location,
});

export interface CoreProductDetailsCardRendererProps
  extends ExtractedObservables<ReturnType<typeof getObservables>> {
  dataCoreBaseProduct: DataCoreBaseProduct;
}

const CoreProductDetailsCardRenderer = ({
  location,
  dataCoreBaseProduct,
}: CoreProductDetailsCardRendererProps) => {
  let matchingLocationPricing = dataCoreBaseProduct.inventoryPricing.find(
    (pricing) => pricing.locationId.toString() == location.retailerLocationKey
  );

  if (!matchingLocationPricing && dataCoreBaseProduct.inventoryPricing.length) {
    // If no location pricing found, try to find the first one
    matchingLocationPricing = dataCoreBaseProduct.inventoryPricing[0];
  }

  if (!matchingLocationPricing) {
    return null;
  }

  return (
    <Card>
      <FlatActionList
        items={[
          {
            key: "stock_on_hand",
            title: "Stock On Hand",
            componentRight: () => {
              return (
                <Text>{matchingLocationPricing.stockOnHand.toString()}</Text>
              );
            },
          },
          {
            key: "price",
            title: "Retail Price",
            componentRight: () => {
              return (
                <Text>
                  {moneyToFormattedString(
                    matchingLocationPricing.stockRetail.toString()
                  )}
                </Text>
              );
            },
          },
        ]}
      />
    </Card>
  );
};

const enhance = withObservables(["stockCount"], getObservables);

export const CoreProductDetailsCard = enhance(
  CoreProductDetailsCardRenderer
) as React.FC<{
  stockCount: StockCount;
  dataCoreBaseProduct: DataCoreBaseProduct;
}>;
